<template>
 <div class="app-container">
   <div style="background-color: rgb(255, 255, 255); position: relative; height: calc(100% + 0px); width: 100%; padding: 20px;">

  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="企业信息" name="first"><enterpriseinfo></enterpriseinfo></el-tab-pane>
    <el-tab-pane label="企业资质" name="second"><businessqualification></businessqualification></el-tab-pane>
    <el-tab-pane label="企业财务" name="third"><financialsituation></financialsituation></el-tab-pane>
    <el-tab-pane label="企业荣誉" name="fourth"><reputation></reputation></el-tab-pane>
    <el-tab-pane label="人员管理" name="five"><personnelstatus></personnelstatus></el-tab-pane>
    <el-tab-pane label="历史案例" name="six"><historicalcases></historicalcases></el-tab-pane>
  </el-tabs>
  </div>
  </div>
</template>

            

<script>
// 企业信息
import  enterpriseinfo from './enterpriseinfo/index.vue'  ;

import businessqualification from './businessqualification/index.vue';
import financialsituation from'./financialsituation/index.vue';
import reputation from'./reputation/index.vue';
import personnelstatus  from './personnelstatus/index.vue'
import historicalcases from './historicalcases/index.vue'
  export default {
      components: { enterpriseinfo,businessqualification,financialsituation,reputation,personnelstatus ,historicalcases},

    data() {
      return {
        activeName: 'second'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    },
      mounted() {
    this.activeName = this.$route.query.tabname
  },
  };
</script>
<style scoped>
.app-container {
padding: 20px;
    position: absolute;
    height: 100%;
    width: 100%;
}
</style>